import { Component } from '@angular/core';
import { AuthStoreService } from '@farm-portal/core/auth/services/auth-store.service';

@Component({
  selector: 'base-auth',
  templateUrl: './base-auth.component.html',
  styleUrls: ['./base-auth.component.scss']
})
export class BaseAuthComponent {
  constructor(private baseAuthStoreService: AuthStoreService) {}

  public hasAccess(componentKey: string, permissionKey: string): boolean {
    const claims = this.baseAuthStoreService.getUserClaims;
    return claims?.includes(`${componentKey}.${permissionKey}`) ?? false;
  }
}
